// extracted by css-extract-rspack-plugin
export default {"pageLoader":"pageLoader__ViZ13","pageLoader_sticky":"pageLoader_sticky__x1iDp"};